import * as Yup from 'yup';
import editCustomer from './editCustomerFormModel';
const {
  formField: {

    // DATOS CLIENTE 
    e_name,
    e_address,
    e_email,
    e_person_in_charge,
    e_contact,
    e_second_person_in_charge,
    e_second_customer_contact,
    e_phone,
    e_start_date,
    e_status,
    e_country,
    e_departament,
    e_municipaly

  }

} = editCustomer;


export default [

  // INFORMACION BASICA 
  Yup.object().shape({ 
    [e_name.name]: Yup.string().required(`${e_name.requiredErrorMsg}`),    
    [e_address.name]: Yup.string().required(`${e_address.requiredErrorMsg}`),
    [e_email.name]: Yup.string().required(`${e_email.requiredErrorMsg}`).email(`${e_email.requiredErrorMsg}`),
    [e_person_in_charge.name]: Yup.string().required(`${e_person_in_charge.requiredErrorMsg}`),
    [e_contact.name]: Yup.number().typeError('El contacto debe ser numerico').label(`${e_contact.typeDataMsg}`).required(`${e_contact.requiredErrorMsg}`),
    [e_second_person_in_charge.name]: Yup.string().optional(),
    [e_second_customer_contact.name]: Yup.number().typeError('El contacto debe ser numerico').label(`${e_second_customer_contact.typeDataMsg}`).optional(),
    [e_phone.name]: Yup.string().required(`${e_phone.requiredErrorMsg}`), 
    [e_start_date.name]: Yup.string().required(`${e_start_date.requiredErrorMsg}`),
    [e_status.name]: Yup.boolean(),
    [e_country.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${e_country.requiredErrorMsg}`),
    [e_departament.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${e_departament.requiredErrorMsg}`),
    [e_municipaly.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${e_municipaly.requiredErrorMsg}`),
  })
  
];  

    